import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Heading } from './NavMenu';

export class Downloads extends React.Component<RouteComponentProps<{}>, {}> {
    
    public render() {
        const sample = {
            awards_file: '../../dist/downloads/sample/Award.csv',
            awardsco_file: '../../dist/downloads/sample/AwardCoInvestigators.csv',
            awardsidentity_file: '../../dist/downloads/sample/AwardIdentity.csv',
            employee_file: '../../dist/downloads/sample/Employee.csv',
            employee_name_file: '../../dist/downloads/sample/EmployeeName.csv',
            vendor_file: '../../dist/downloads/sample/Vendor.csv',
            subaward_file: '../../dist/downloads/sample/Subaward.csv',
            objcodes_file: '../../dist/downloads/sample/ObjectCodes.csv',
            orgunits_file: '../../dist/downloads/sample/OrgUnits.csv'
        }

        const onboarding = {
            datadictionary_file: '../../dist/downloads/onboarding/dataDictionary.pdf',
            starcodes_file: '../../dist/downloads/onboarding/StarOFSCodes.pdf',
            field_file: '../../dist/downloads/onboarding/FileAndFieldGuide.pdf'
        }

        return <div className='container-fluid'>
            <div className="row">
                <div className="col-md-12">
                    <Heading value='Documents' />
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    
                    <table className='downloads table'>
                        <tbody>
                        <tr>
                            <td className="firstcolumn" rowSpan={9}>Upload Sample Files</td>
                            <td>Award</td>
                            <td><a href={sample.awards_file} target="_blank"><i className="fa fa-download"></i>Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>Award CoInvestigators</td>
                            <td><a href={sample.awardsco_file} target="_blank"><i className="fa fa-download"></i>Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>Award Identity</td>
                            <td><a href={sample.awardsidentity_file} target="_blank"><i className="fa fa-download"></i>Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>Employee</td>
                            <td><a href={sample.employee_file} target="_blank"><i className="fa fa-download"></i>Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>Employee Name</td>
                            <td><a href={sample.employee_name_file} target="_blank"><i className="fa fa-download"></i>Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>Vendor</td>
                            <td><a href={sample.vendor_file} target="_blank"><i className="fa fa-download"></i>Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>Sub Awards</td>
                            <td><a href={sample.subaward_file} target="_blank"><i className="fa fa-download"></i>Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>Object Codes</td>
                            <td><a href={sample.objcodes_file} target="_blank"><i className="fa fa-download"></i>Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>Organizational Units</td>
                            <td><a href={sample.orgunits_file} target="_blank"><i className="fa fa-download"></i>Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td className="firstcolumn" rowSpan={3}>Onboarding Documents</td>
                            <td>Data Dictionary</td>
                            <td><a href={onboarding.datadictionary_file} target="_blank"><i
                                className="fa fa-download"></i>Download</a></td>
                        </tr>
                        <tr>
                            <td>Data Submission File and Field Descriptions</td>
                            <td><a href={onboarding.field_file} target="_blank"><i className="fa fa-download"></i>Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td>STAR OFS (Other Funding Sources) Codes</td>
                            <td><a href={onboarding.starcodes_file} target="_blank"><i className="fa fa-download"></i>Download</a>
                            </td>
                        </tr>
                        <tr>
                            <td className="firstcolumn" rowSpan={6}>IRIS Webinars</td>
                            <td>IRIS 101: An Introduction to the Institute for Research on Innovation and Science</td>
                            <td><a href="https://www.youtube.com/watch?v=guguoL6_9Qk" target="_blank"><i
                                className="fa fa-youtube-play"></i>&nbsp;&nbsp;View</a></td>
                        </tr>
                        <tr>
                            <td>Find Compelling Research Impact Stories with IRIS</td>
                            <td><a href="https://www.youtube.com/watch?v=gJk2vCyvfSo" target="_blank"><i
                                className="fa fa-youtube-play"></i>&nbsp;&nbsp;View</a></td>
                        </tr>
                        <tr>
                            <td>Webinar: Measuring Research Impact for Internal Audiences and Government Relations</td>
                            <td><a href="https://www.youtube.com/watch?v=9aohfL8rnIA" target="_blank"><i
                                className="fa fa-youtube-play"></i>&nbsp;&nbsp;View</a></td>
                        </tr>
                        <tr>
                            <td>Tracking the Career Outcomes of Research-Funded Employees</td>
                            <td><a href="https://www.youtube.com/watch?v=K6sh0GpOdT4" target="_blank"><i
                                className="fa fa-youtube-play"></i>&nbsp;&nbsp;View</a></td>
                        </tr>
                        <tr>
                            <td>2024 IRIS UMETRICS Data Release: Highlights, Access, Census Data Linkage, and Research
                                Applications
                            </td>
                            <td><a href="https://www.youtube.com/watch?v=jTp3AEstCmc" target="_blank"><i
                                className="fa fa-youtube-play"></i>&nbsp;&nbsp;View</a></td>
                        </tr>
                        <tr>
                            <td>Unlocking the Power of IRIS Reports: Spending Report
                            </td>
                            <td><a href="https://www.youtube.com/watch?v=OCECYh9MyX8" target="_blank"><i
                                className="fa fa-youtube-play"></i>&nbsp;&nbsp;View</a></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>;
    }
}